import React, { useEffect } from 'react'
import Banner from '../landing/main-banner/Banner'
import Footer from '../landing/footer/Footer'
import Benifits from './Benifits/Benifits'
import Working from './working/Working'
import Evolve from '../landing/Evolvetomi/Evolve'
import Getapp from './getapp/Getapp'
import Bannerchatandrepay from './Bannerchatandrepay'
import Ourstory from './Ourstory/Ourstory'
import Ourvisson from './ourvission/Ourvisson'

export const Aboutuslanding = () => {
  useEffect(() => {
      window.scrollTo(0, 0)
    }, [])
  return (
    <>
    <Bannerchatandrepay/>
    <Ourstory/>
    <Ourvisson/>
    <Working/>
    <Benifits/>
    <Evolve/>
    <Getapp/>
    <Footer/>
    </>
  )
}
